import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import { PerformanceCyclesCycleFilterDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { NO_CYCLE_OPTION } from 'modules/performance_cycles/components/CycleFilter'

interface Params {
  storageKeySuffix?: string // Useful for storing the filter value for a specific page and not overriding the global one
}

export const useCycleFilterStorage = ({ storageKeySuffix }: Params = {}) =>
  useLocalStorage<string | null>(
    [LOCAL_STORAGE_KEYS.performanceCyclesCycleFilter, storageKeySuffix].join(':')
  )

export const useCycleFilter = ({ storageKeySuffix }: Params = {}) => {
  const [cycleId, setCycleId] = useCycleFilterStorage({ storageKeySuffix })

  const noCycleSelected = cycleId === NO_CYCLE_OPTION
  const value = noCycleSelected ? null : cycleId

  const { data, loading } = useQuery(PerformanceCyclesCycleFilterDocument, {
    onCompleted: ({ performanceCycles }) => {
      if (!noCycleSelected && performanceCycles.cycles.every(({ id }) => id !== cycleId)) {
        setCycleId(null)
      }
    },
  })

  const cycles = data?.performanceCycles.cycles ?? []

  return {
    cycle: cycles.find((cycle) => cycle.id === cycleId),
    loading,
    props: {
      cycles,
      value,
      noCycleSelected,
      onChange: setCycleId,
    },
  }
}
